import { Component, inject, input, Input, model, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AllStatus } from '../../../../core/services/status/all-status';
import { PlayersService } from '../../../services/players/players';
import { ActivatedRoute, Router } from '@angular/router';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { GameInfoService } from '../../../services/games/game-info';
import { RdGameService } from '../../../services/games/rd-game';
import { FieldBuilder } from '../../../services/fields/field-builder';
import { ListQuest } from '../../../services/lists/list-quest';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExitWaitingWindow } from '../../../dialogs/exit-waiting-window/exit-waiting-window';
import { Downtime } from '../../../../core/services/times/downtime';
import { ConfirmStartGame } from '../../../dialogs/confirm-start-game/confirm-start-game';
import { DifficultyLevel } from '../../../services/levels/difficulty-level';
import { ConfirmNotAllPlayers } from '../../../dialogs/confirm-not-all-players/confirm-not-all-players';
import { NotificationService } from '../../../../core/services/Notification/notification';

@Component({
  selector: 'app-tmp-wt-finished',
  imports: [TranslatePipe, MatProgressBarModule],
  templateUrl: './tmp-wt-finished.html',
  styleUrl: './tmp-wt-finished.scss'
})
export class TmpWtFinished  { 
  readonly dialog = inject(MatDialog);
  player = model<any>();
  roomInfo = input<any>();
  data =  input<any>();

  //@Input() player: any;
  allStatus = inject(AllStatus);
  downtime = inject(Downtime);
  players = inject(PlayersService);
  activatedRoute = inject(ActivatedRoute);
  fieldBuilder = inject(FieldBuilder);
  uuid = this.activatedRoute.snapshot.paramMap.get('id') as string;
  gameInfo = inject(GameInfoService);
  router = inject(Router);
  rdUse = inject(RdGameService);
  quests = inject(ListQuest);
  isGoToGame:boolean = true;
  translate = inject(TranslateService);

  difficulty = inject(DifficultyLevel);
  notification = inject(NotificationService);
  txtDialog: any;

  isExitGame: boolean = false;
  subscriptionCL: import("rxjs").Subscription;
  
  
  constructor(){
    this.isExitGame = false;
    this.isGoToGame = true;
    this.loadTranslateText();
     this.subscriptionCL = this.allStatus.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.loadTranslateText();
      }
     });
  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }



  onSwitch(){
    this.allStatus.textSpinner = this.txtDialog?.txtEditing;
    this.allStatus.setDisplayProgressSpinner(true);   
    this.downtime.refreshTimer(); 
    this.player.set({...this.player(), is_ready: false });
    
    this.allStatus.setEditUserInWaiting(true);
    this.allStatus.isEditUserInWaiting = true;
    // TODO поки відключеться 
    this.players.savePlayer(this.player(), this.uuid).subscribe({
      next: ()=>{
        void this.rdUse.updatePlayerInGameById(this.player(), this.uuid).then(() =>{
          this.router.navigate([`/waiting/${this.uuid}`]);
        }).catch((error: any) =>{
          this.allStatus.setDisplayProgressSpinner(false);
          this.notification.setMessage(error?.message ?? 'Failed to update player in the game');
          this.notification.display();
        });
      },
      error: (error: any) =>{
        this.allStatus.setDisplayProgressSpinner(false);
        this.notification.setMessage(error?.error?.message ?? error?.message ?? 'Failed to save player');
        this.notification.display();
      },
    });
  }

  onGoToGame(){
    this.downtime.refreshTimer();
    if(this.roomInfo().maximum_players === 1){
      this.runGoToGame();
    }else{
      const isReadyPlayers:boolean = this.isAllPlayersIsReady();
      const isLenght: boolean = this.isAllLenght();
      if(isReadyPlayers && isLenght){
        this.runGoToGame();
      }else{
        if( (this.data().length) < this.roomInfo().maximum_players ){
          this.showModalWindowNotAllPlayers();
        }else{
          this.showModalWindow();
        }
        
      }
    }
        
    
  }

  runGoToGame(){
    this.isGoToGame = false;
    this.allStatus.textSpinner = this.txtDialog?.txtStarting;
    this.allStatus.setDisplayProgressSpinner(true);
    this.deleteplayerIfNotReady();
    this.gameInfo.startGame(this.uuid, this.allStatus.selectLevel()).subscribe((result: any)=>{
      // list players 
      let cpRoom = structuredClone(result.room);
      cpRoom.players.forEach(( plr: any) => {
        if(plr.is_ready){
          let listField: any = this.fieldBuilder.playerFields(cpRoom.players, plr, cpRoom.type);
          plr.my_field = listField;
          plr.successesInGame = 0;
        } 
      });
      cpRoom.playersFields = this.fieldBuilder.playersFieldId;
      void this.rdUse.updateStatusGameInprogress(this.player().player_id, cpRoom).catch((error) =>{
        console.error(`Failed to update game status for room ${this.uuid}`, error);
      });
    });
  }
  deleteplayerIfNotReady() {
    let listId: Array<number> = [];
    this.data().forEach((item: any)=>{
      if(!item.is_ready){
        listId.push(item.player_id);
      }
    });
    this.players.processDeleteUserNotReady(this.uuid, listId);
  }

  // TODO не всі готові до гри
  showModalWindow(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    const dialogRef = this.dialog.open(ConfirmStartGame, dialogConfig);
    dialogRef.afterClosed().subscribe(result=>{
      if(result){
        this.runGoToGame();
      }
    });
  }

  //TODO - не всі приєднались
  showModalWindowNotAllPlayers(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    
    const dialogRef = this.dialog.open(ConfirmNotAllPlayers, dialogConfig);
    dialogRef.afterClosed().subscribe(result=>{
      if(result){
        this.runGoToGame();
      }
    });
  }


windowExitGame(){
  this.downtime.refreshTimer();
  const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    const dialogRef = this.dialog.open(ExitWaitingWindow, dialogConfig);
    dialogRef.afterClosed().subscribe(result=>{
      if(result){
        this.isExitGame = true;
        if(this.player().is_starter){
          this.allStatus.textSpinner = this.txtDialog?.txtCanceling;
        }else{
          this.allStatus.textSpinner = this.txtDialog?.txtCancelKoop;
        }
        //this.allStatus.textSpinner = this.txtDialog?.txtCanceling;
        this.allStatus.setDisplayProgressSpinner(true); 
        this.onExitRoom();
      }
    });
  }

  onExitRoom(){
    // if(this.players.player.is_starter){
    //   this.gameInfo.finishGame(this.uuid); 
    // } 
    this.quests.clearStorage();
    this.difficulty.clear();
    this.allStatus.clearNowCard();
    this.allStatus.clearExplanationTxt();
    this.allStatus.setChangeUuId('');
    this.allStatus.isEditUserInWaiting = false;
    if(this.player().is_starter){
      this.players.processDeletePlayersAndClosed(this.uuid, this.getAllPlayersId());
      this.players.detelePlayerStarter(this.uuid);
      //this.gameInfo.closedGame(this.uuid); 
    }else{
      this.players.detelePlayer(this.uuid);
      window.location.assign('/games');
      // this.router.navigate(['/games']);
    }
    
  }

  private isAllPlayersIsReady(){
    let isReady: boolean = true;
    this.data().forEach((item: any)=>{
      if(!item.is_ready){
        isReady = false;
      }
    });
    return isReady;
  }

  private getAllPlayersId(){
    let listId: Array<number> = [];
    this.data().forEach((item: any)=>{
      listId.push(item.player_id);
    });
    return listId;
  }

  private isAllLenght(){
    return (this.data().length) === this.roomInfo().maximum_players;
  }


  isDisabled(): boolean{
    let isDisabled: boolean = false;
    if(2 <= this.roomInfo().maximum_players){
      if(this.data().length < 2){
        isDisabled = true;
      }
      if(this.data().length === 2){
        this.isAllPlayersIsReady() ? isDisabled = false : isDisabled = true;
      }
      if(this.data().length  > 2){
        this.isTwoPlayersIsReady() ? isDisabled = false : isDisabled = true;
      }
    }
    return isDisabled;}

    private isTwoPlayersIsReady(): boolean{
      let isReady: boolean = false;
      let countReady: number = 0;
      this.data().forEach((item: any)=>{
        if(item.is_ready){
          countReady++;
        }
      });
      if(countReady >= 2){
        isReady = true;
      }
      return isReady;
    }

}
